import classNames from 'classnames';
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';
import { useEffect } from 'react';
import styles from './cookie-consent.module.css';

export function hasDeclinedCookieConsent() {
    const value = getCookieConsentValue('bpm-cookie-consent');
    return value === 'false';
}

export function CookieConsentBanner() {
    const onDecline = () => {
        if (typeof window !== 'undefined') {
            // eslint-disable-next-line @typescript-eslint/dot-notation
            (window as any)[`ga-disable-${process.env['NEXT_PUBLIC_GTM_ID']}`] = true;
        }
    };

    useEffect(() => {
        if (hasDeclinedCookieConsent()) {
            onDecline();
        }
    }, []);

    return (
        <CookieConsent
            location="bottom"
            buttonText="Accept All Cookies"
            cookieName="bpm-cookie-consent"
            containerClasses={styles['cookie-consent__container']}
            enableDeclineButton
            onDecline={onDecline}
            declineButtonText="Use Essential Only"
            contentStyle={{ margin: 0, flex: 0 }}
            buttonClasses={classNames(styles['cookie-consent__button'], styles['cookie-consent__button--accept'])}
            declineButtonClasses={classNames(styles['cookie-consent__button'], styles['cookie-consent__button--decline'])}
            buttonWrapperClasses={styles['cookie-consent__button-container']}
            expires={365}
        >
            <div className={styles['cookie-consent__content']}>
                <h3 className={styles['cookie-consent__header']}>Privacy & Data Usage</h3>
                <p className={classNames(styles['cookie-consent__message'])}>
                    We use cookies and similar technologies to improve your experience and analyze site traffic.
                </p>
                <span className={classNames(styles['cookie-consent__message-link'])}>For more details, see our Privacy&nbsp;</span>
                <a href="https://bpmmusic.io/privacy-policy" target="_blank" className={classNames(styles['cookie-consent__message-link'], 'underline-link')} rel="noreferrer">Privacy Policy</a>
                <span className={classNames(styles['cookie-consent__message-link'])}>&nbsp;and&nbsp;</span>
                <a href="https://bpmmusic.io/terms" target="_blank" className={classNames(styles['cookie-consent__message-link'], 'underline-link')} rel="noreferrer">Terms of Use</a>
                <span className={classNames(styles['cookie-consent__message-link'])}>.</span>
            </div>
        </CookieConsent>
    );
}
